import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";
import {useQueryUser} from "@/service/user.s";
import Chip from "@mui/material/Chip";

export const ViewUser = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: userData, isLoading: userLoading} = useQueryUser({id: drawerId!}, isNumber(drawerId))
    const user = userData?.data
    return <> <ResultWrapper isLoading={userLoading} isEmpty={isEmpty(user)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'姓名'} content={user?.username}/>
                <GridItem title={'账号'} content={user?.account}/>
                <GridItem title={'联系电话'} content={user?.mobile}/>
                <GridItem title={'邮箱'} content={user?.email}/>
                <GridItem title={'性别'} content={user?.gender == 1 && '男' || user?.gender == 2 && '女' || "未知"}/>
                <GridItem title={'入职时间'} content={formatTime('D', user?.entryTime)}/>
                <GridItem title={'角色'} content={user?.role?.roleName}/>
                <GridItem title={'部门'} content={user?.dept?.deptName}/>
                <GridItem title={'状态'} content={<Chip variant={'outlined'} color={user?.statusId == 2 ? 'success' : 'warning'} label={user?.status}/>}/>
                <GridItem title={'登录IP'} content={user?.signinIp}/>

                <GridItem minHeight={'48px'} size={12} title={'备注说明'} content={user?.remark || '-'}/>
                <GridItem title={'更新时间'} content={formatTime('D', user?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', user?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}